export default {
  'clients/client': 13,
}
